module.exports = __webpack_public_path__ + "media/images/official/about_yamori_bg-4dc1faaa4d1795ed44ac5cbf7afb744a.jpg";